/* Dolls & Dreams cinematic direction: functional, accessible, mobile-first */
(()=>{'use strict';
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
const playVideo=video=>{
 if(!video)return;
 video.muted=true;video.playsInline=true;
 try{const p=video.play();if(p&&p.catch)p.catch(()=>{});}catch(e){}
};
function initFilm(root){
 if(root.dataset.ddxInitialized)return;root.dataset.ddxInitialized='yes';
 const scenes=Array.from(root.querySelectorAll('[data-ddx-scene]'));
 const controls=Array.from(root.querySelectorAll('[data-ddx-select]'));
 const counter=root.querySelector('[data-ddx-current]');
 const toggle=root.querySelector('[data-ddx-pause]');
 const play=root.querySelector('[data-ddx-play]');
 const videos=scenes.map(x=>x.querySelector('video'));
 if(!scenes.length)return;
 
 let active=0,paused=reduced.matches,inView=true,timer=null,hovering=false;
 const getDuration=index=>index===0?7400:4600;
 function syncPlayback(){if(play&&!videos[active])play.hidden=true;
  videos.forEach((video,i)=>{
   if(!video)return;
   if(i===active&&!paused&&inView&&!document.hidden&&!reduced.matches){
    video.muted=true;video.playsInline=true;
    const attempt=video.play();
    if(attempt&&attempt.then)attempt.then(()=>{if(play)play.hidden=true}).catch(()=>{if(play)play.hidden=false});
   }else video.pause();
  });
 }
 function switchTo(index){
  active=(index+scenes.length)%scenes.length;
  scenes.forEach((scene,i)=>{
   const selected=i===active;
   scene.classList.toggle('is-active',selected);
   scene.setAttribute('aria-hidden',String(!selected));
   scene.querySelectorAll('a').forEach(a=>a.tabIndex=selected?0:-1);
  });
  controls.forEach((control,i)=>{
   const selected=i===active;
   control.classList.toggle('is-active',selected);
   control.setAttribute('aria-current',String(selected));
   const line=control.querySelector('span');
   if(selected&&line){line.style.animation='none';void line.offsetWidth;line.style.animation='';}
  });
  if(counter)counter.textContent=String(active+1).padStart(2,'0');
  syncPlayback();
  if(videos[(active+1)%videos.length])videos[(active+1)%videos.length].preload='metadata';
 }
 function schedule(){
  if(timer)clearTimeout(timer);
  if(!paused&&!reduced.matches&&scenes.length>1){
   timer=setTimeout(()=>{
    if(inView&&!document.hidden)switchTo(active+1);
    schedule();
   },getDuration(active));
  }
 }
 controls.forEach((control,i)=>control.addEventListener('click',()=>{switchTo(i);schedule()}));
 if(toggle)toggle.addEventListener('click',()=>{
  paused=!paused;root.toggleAttribute('data-ddx-paused',paused);
  toggle.textContent=paused?'▶':'Ⅱ';
  toggle.setAttribute('aria-label',paused?'Play moving campaign':'Pause moving campaign');
  syncPlayback();schedule();
 });
 if(play)play.addEventListener('click',()=>{
  paused=false;root.removeAttribute('data-ddx-paused');
  if(toggle){toggle.textContent='Ⅱ';toggle.setAttribute('aria-label','Pause moving campaign');}
  playVideo(videos[active]);syncPlayback();schedule();
 });
 let cursorRaf=null,cursorX='70%',cursorY='33%';
root.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse')return;const rect=root.getBoundingClientRect();cursorX=((e.clientX-rect.left)/rect.width*100).toFixed(1)+'%';cursorY=((e.clientY-rect.top)/rect.height*100).toFixed(1)+'%';if(cursorRaf)return;cursorRaf=requestAnimationFrame(()=>{root.style.setProperty('--ddx-cursor-x',cursorX);root.style.setProperty('--ddx-cursor-y',cursorY);
const fx=((parseFloat(cursorX)-50)*.16).toFixed(2)+'px';
const fy=((parseFloat(cursorY)-50)*.13).toFixed(2)+'px';
root.style.setProperty('--ddx-film-x',fx);
root.style.setProperty('--ddx-film-y',fy);
cursorRaf=null;})},{passive:true});
root.addEventListener('mouseenter',()=>{hovering=true});
 root.addEventListener('mouseleave',()=>{hovering=false});
 root.addEventListener('focusin',()=>{hovering=true});
 root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget))hovering=false});
 let touchStart=0;
 root.addEventListener('touchstart',e=>{touchStart=e.changedTouches[0].clientX},{passive:true});
 root.addEventListener('touchend',e=>{
  const difference=e.changedTouches[0].clientX-touchStart;
  if(Math.abs(difference)>70){switchTo(active+(difference<0?1:-1));schedule();}
 },{passive:true});
 if('IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>{
   inView=entries[0].isIntersecting;
   syncPlayback();
   if(!root.isConnected){observer.disconnect();if(timer)clearInterval(timer);}
  },{threshold:.07});
  observer.observe(root);
 }
 document.addEventListener('visibilitychange',syncPlayback);
 if(paused){root.setAttribute('data-ddx-paused','');if(toggle){toggle.textContent='▶';toggle.setAttribute('aria-label','Play moving campaign');}}
 switchTo(0);schedule();
}
function initLookbook(root){
 if(root.dataset.ddxInitialized)return;root.dataset.ddxInitialized='yes';
 const buttons=Array.from(root.querySelectorAll('[data-ddx-look-select]'));
 const slides=Array.from(root.querySelectorAll('[data-ddx-look-slide]'));
 const count=root.querySelector('[data-ddx-look-count]');
 if(!slides.length)return;
 function show(index){
  const wanted=(index+slides.length)%slides.length;
  buttons.forEach((btn,i)=>{const active=i===wanted;btn.classList.toggle('is-active',active);btn.setAttribute('aria-current',String(active));});
  slides.forEach((slide,i)=>{
   const active=i===wanted;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));
   slide.querySelectorAll('a').forEach(a=>a.tabIndex=active?0:-1);
  });
  if(count)count.textContent=String(wanted+1).padStart(2,'0');
 }
 buttons.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
 const gallery=root.querySelector('.ddx-look__gallery');
 const canTilt=window.matchMedia('(min-width:990px) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
 let tiltFrame=null;
 const resetDepth=()=>{
  if(tiltFrame!==null){cancelAnimationFrame(tiltFrame);tiltFrame=null}
  if(!gallery)return;
  gallery.style.setProperty('--ddx-look-rx','0deg');
  gallery.style.setProperty('--ddx-look-ry','0deg');
  gallery.style.setProperty('--ddx-look-x','0px');
  gallery.style.setProperty('--ddx-look-y','0px');
  gallery.style.setProperty('--ddx-look-light-x','50%');
  gallery.style.setProperty('--ddx-look-light-y','30%');
 };
 if(gallery){
  gallery.addEventListener('pointermove',event=>{
   if(!canTilt.matches||event.pointerType!=='mouse'||tiltFrame!==null)return;
   const rect=gallery.getBoundingClientRect();
   const dx=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
   const dy=Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1));
   tiltFrame=requestAnimationFrame(()=>{
    gallery.style.setProperty('--ddx-look-ry',(dx*2.4).toFixed(2)+'deg');
    gallery.style.setProperty('--ddx-look-rx',(-dy*1.6).toFixed(2)+'deg');
    gallery.style.setProperty('--ddx-look-x',(-dx*8).toFixed(1)+'px');
    gallery.style.setProperty('--ddx-look-y',(-dy*6).toFixed(1)+'px');
    gallery.style.setProperty('--ddx-look-light-x',(50+dx*22).toFixed(1)+'%');
    gallery.style.setProperty('--ddx-look-light-y',(30+dy*22).toFixed(1)+'%');
    tiltFrame=null;
   });
  },{passive:true});
  gallery.addEventListener('pointerleave',resetDepth);
  gallery.addEventListener('focusin',resetDepth);
 }

 let start=0;
 root.querySelector('.ddx-look__gallery')?.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX},{passive:true});
 root.querySelector('.ddx-look__gallery')?.addEventListener('touchend',e=>{
  const diff=e.changedTouches[0].clientX-start;if(Math.abs(diff)>65)show((buttons.findIndex(b=>b.classList.contains('is-active'))+slides.length+(diff<0?1:-1))%slides.length);
 },{passive:true});
 show(0);
}
function initMobileBuy(bar){if(bar.dataset.ready)return;bar.dataset.ready="1";const buy=document.querySelector(".product-form__buttons");const target=document.querySelector(".product-form__input")||buy;const refresh=()=>{const small=innerWidth<=749;const rect=buy?.getBoundingClientRect();bar.hidden=!(small&&scrollY>240&&(!rect||rect.top>innerHeight-70||rect.bottom<0))};bar.querySelector("[data-ddx-sizes]")?.addEventListener("click",()=>{target?.scrollIntoView({behavior:"smooth",block:"center"});target?.querySelector('input[type="radio"]:checked,input[type="radio"],select')?.focus({preventScroll:true})});addEventListener("scroll",refresh,{passive:true});addEventListener("resize",refresh,{passive:true});refresh()}
function init(scope=document){
 scope.querySelectorAll('[data-ddx-film]').forEach(initFilm);
 scope.querySelectorAll('[data-ddx-look]').forEach(initLookbook);scope.querySelectorAll('[data-ddx-mobile-purchase]').forEach(initMobileBuy);
 const sections=scope.querySelectorAll('.ddat-story,.ddocc,.dd-detail,.dds,.ddat-closer');
 if(reduced.matches||!('IntersectionObserver' in window)){sections.forEach(el=>el.classList.add('ddx-seen'));return;}
 if(!document.documentElement.classList.contains('ddx-motion-ready'))document.documentElement.classList.add('ddx-motion-ready');
 const revealObserver=new IntersectionObserver(entries=>{
  entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ddx-seen');revealObserver.unobserve(entry.target);}}
  );
 },{rootMargin:'0px 0px -7% 0px',threshold:.08});
 sections.forEach(el=>{if(!el.classList.contains('ddx-seen'))revealObserver.observe(el);});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>init())}else init();
document.addEventListener('shopify:section:load',e=>init(e.target));
})();